import axios from "axios";
import { API_ENDPOINTS } from "../api-urls";

// Function to verify reCAPTCHA token via custom back-end API
export const verifyRecaptchaToken = async (token) => {
  try {
    console.log("Verifying reCAPTCHA token...", token);

    const response = await axios.post(API_ENDPOINTS.recaptcha, { token }); // Custom back-end endpoint
    console.log("reCAPTCHA Verification Response:", response.data);

    if (!response.data.success) {
      throw new Error("reCAPTCHA verification failed");
    }

    return response.data; // Return the full response in case back-end provides additional data
  } catch (error) {
    console.error(
      "Error verifying reCAPTCHA token:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

// Function to submit the contact form (without token)
export const submitContactForm = async (formData) => {
  try {
    console.log("Submitting contact form...", formData);

    const response = await axios.post(API_ENDPOINTS.contactUs, formData);

    console.log("Contact Form Submission Success:", response.data);
    return response.data;
  } catch (error) {
    console.error(
      "Error submitting contact form:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

// Function to fetch FAQs
export const fetchFAQs = async () => {
  try {
    console.log("Fetching FAQs...");
    const response = await axios.get(API_ENDPOINTS.faqs);
    console.log("FAQs Fetched Successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching FAQs:", error.response ? error.response.data : error.message);
    return [];
  }
};

// Function to fetch Size Guide
export const fetchSizeGuide = async () => {
  try {
    console.log("Fetching Size Guide...");
    const response = await axios.get(API_ENDPOINTS.sizeGuide);
    console.log("Size Guide Fetched Successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching Size Guide:", error.response ? error.response.data : error.message);
    return [];
  }
};